import React from 'react';
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth } from "../../config/firebase/firebase.js"; // Adjust path if needed
import googleIcon from "../../../src/components/assets/images/google.svg"

const FirebaseGoogleLogin = ({ onSuccess, onFailure }) => {
  const handleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      // On success, pass the verifiable ID token up to the parent.
      const idToken = await result.user.getIdToken();

      const email = result.user.email;
      onSuccess(email, 'firebase'); // Pass token and method type
    } catch (error) {
      console.error("Firebase login error:", error);
      onFailure({ error: "Firebase login failed." });
    }
  };

  return (
    <button
      onClick={handleLogin}
      style={{
        height: 60,
        width: 300,
        fontSize: 15,
        color: '#454f63',
        backgroundColor: '#f7f7fa',
        borderRadius: 12,
        border: 'none',
        outline: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'SF Pro Display Medium',
      }}
    >
      <img src={googleIcon} alt='' style={{ marginRight: '15px' }} />
      <span>Sign in with Google (Firebase)</span>
    </button>
  );
};

export default FirebaseGoogleLogin;
